export const getPropertyPathname = (pathname: string): boolean => {
  return /\bproperty\b/i.test(pathname)
}
